
const defaultList = [
  "https://ezt3.eastfair.com",
  "https://izt.eastfair.cn",
]

export default {
  "242873": [
    "https://my.31huiyi.com",
    "https://oauth.31huiyi.com",
    "https://xzt.eastfair.com",
    "https:qgtjh.eastfair.cn",
    "https:qgtjh-pc.eastfair.cn"
  ].concat(defaultList)
}
